export default function RegistresRoute($stateProvider) {
	$stateProvider.state('registres', {
		parent: 'gestion',
		url: '/registres',
		views: {
			gestion: {
				template: '<ui-view></ui-view>'
			}
		},
		ncyBreadcrumb: {
			label: '{{ "LAYOUT.NAVIGATION.PESEES_FACTURATIONS" | translate }}'
		}
	});

	// DPE - RNDTS BRGM -> A SUPPRIMER AVEC LE RETRAIT DE LA FONCTIONNALITE
	$stateProvider.state('registres.rndts', {
		url: '/rndts',
		template: '<registres-legacy></registres-legacy>',
		rights: { domain: 'brgmrndts', right: 'read' },
		ncyBreadcrumb: {
			parent: 'registres',
			label: '{{ "REGISTRES.BREADCRUMBS.REGISTRES_RNDTS" | translate}}'
		},
		navigation: {
			menu: 'registres',
			translate: 'REGISTRES.BREADCRUMBS.REGISTRES_RNDTS',
			order: 1
		},
		search: 'REGISTRES.BREADCRUMBS.REGISTRES_RNDTS'
	});

	// TRACKDECHETS TEXS
	$stateProvider.state('registres.texs', {
		url: '/texs',
		template: '<texs></texs>',
		rights: { domain: 'trackdechets', right: 'read' },
		ncyBreadcrumb: {
			parent: 'registres',
			label: '{{ "REGISTRES.BREADCRUMBS.REGISTRES_TD" | translate}}'
		},
		navigation: {
			menu: 'registres',
			translate: 'REGISTRES.BREADCRUMBS.REGISTRES_TD',
			order: 1
		},
		search: 'REGISTRES.BREADCRUMBS.REGISTRES_TD'
	});

	// DPE - TEMPORAIRE EN ATTENTE DE LA RESTRUCTURATION REP
	$stateProvider.state('registres.rep', {
		url: '/rep',
		template: '<rep-legacy></rep-legacy>',
		rights: { domain: 'rep', right: 'read' },
		ncyBreadcrumb: {
			parent: 'registres',
			label: '{{ "REGISTRES.BREADCRUMBS.REGISTRES_REP" | translate}}'
		},
		navigation: {
			menu: 'registres',
			translate: 'REGISTRES.BREADCRUMBS.REGISTRES_REP',
			order: 1
		},
		search: 'REGISTRES.BREADCRUMBS.REGISTRES_REP'
	});

	// $stateProvider.state('registres.rep', {
	// 	url: '/home',
	// 	template: '<rep><rep>',
	// 	rights: { domain: 'trackdechets', right: 'read' },
	// 	ncyBreadcrumb: {
	// 		parent: 'registres',
	// 		label: '{{ "REGISTRES.BREADCRUMBS.REGISTRES_REP" | translate}}'
	// 	},
	// 	navigation: {
	// 		menu: 'registres',
	// 		translate: 'REGISTRES.BREADCRUMBS.REGISTRES_REP',
	// 		order: 1
	// 	},
	// 	search: 'REGISTRES.BREADCRUMBS.REGISTRES_REP'
	// });
}

RegistresRoute.$inject = ['$stateProvider'];
